export default "__VITE_ASSET__CUEpSGMN__"